<template>
  <div class="modal-permitir-camera">
    <Modal
        modal-id="modalPermitirCamera"
        :show-close-button="false"
        title=""
        text="Permitir que o app Vivo acesse a sua câmera?"
        button-close-text="Recusar"
        button-confirm-text="Permitir"
        v-bind:callback-confirm-button="callbackConfirmButton"
        v-bind:callbackCloseButton="callbackCloseButton"
        data-backdrop="static"
    ></Modal>
  </div>
</template>

<script>


import Modal from "./Modal";
import GTMService from "../../services/GTMService";
export default {
  name: "ModalCamera",
  components: {Modal},
  props:{
    callbackConfirmButton: {type: Function},
    callbackCloseButton: {type: Function}
  },
  methods:{
    show:function (){
      $('#modalPermitirCamera').modal();
    },
    checkCompatibilidade:function (){
      let compatibilidade = ("mediaDevices" in navigator && "getUserMedia" in navigator.mediaDevices);
      if(!compatibilidade){
        GTMService.dispatchScreenView('errorCantAccessCamera');
      }
      return compatibilidade;
    },
  }
}
</script>

<style scoped>
</style>
<style>
#modalPermitirCamera{
  transform: translateY(25%);
}
#modalPermitirCamera .modal-body{
  padding-bottom: 0;
  margin-bottom: 0;
  padding-top: 2rem;
}
#modalPermitirCamera .modal-footer{
  padding-top: 0;
  margin-top: 0;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ModalCamera.vue